import { forwardRef } from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  contextMenu: {
    position: "absolute",
    "background-color": "rgba(0, 0, 0, 0.7)",
    "border-radius": 3,
    overflow: "hidden",
    color: "white",
    "z-index": 1000,
  },
});

const ContextMenu = forwardRef(({ position, children }, ref) => {
  const classes = useStyles();
  return (
    <div
      ref={ref}
      className={classes.contextMenu}
      style={{
        top: position.top,
        left: position.left,
      }}
    >
      {children}
    </div>
  );
});

export default ContextMenu;
